import { render, staticRenderFns } from "./EffarigRunUnlockReward.vue?vue&type=template&id=7ba5964f&"
import script from "./EffarigRunUnlockReward.vue?vue&type=script&lang=js&"
export * from "./EffarigRunUnlockReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports